import type { IModalConfig } from './types';

import { merge } from '../../helper';

import exLanguage from '../../language';
import * as exModal from './modal';

// ----------------------------------------------------------------------------

export interface IModalMessage extends IModalConfig {
    type?: string;
    title?: string;
    message?: string;
    textAction?: string;
    classAction?: string;
    fnAction?: any;
}

// ----------------------------------------------------------------------------

function message(config: IModalMessage = {}): Record<string, any> {
    // Default Config
    const defConfig: Record<string, any> = {
        modalHeader: {
            type: config.type,
            title: {
                html: config.title ?? exLanguage.line('modal.title'),
            },
        },
        modalBody: {
            html: config.message ?? exLanguage.line('modal.message'),
        },
        buttons: [
            {
                html: config.textAction ?? exLanguage.line('general.ok'),
                class: {
                    new: config.classAction ?? 'btn btn-secondary',
                },
                fnAction: config.fnAction,
            },
        ],
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    // Create element (modal)
    const modal = exModal.start({
        merge: defConfig,
        destroy: true,
    });

    // Return
    return modal;
}

// ----------------------------------------------------------------------------

export default message;
